import React from 'react';

import InputNumber, { InputNumberProps } from 'common/components/InputNumber';
import getMaxCurrencyDecimals from 'modules/menu/components/getCurrencyMaxDecimals';

type Props = Omit<InputNumberProps, 'decimals'> & {
  currency: Currency;
};

const InputMonetary = ({ currency, suffixText, ...rest }: Props) => {
  const maxCurrencyDecimals = getMaxCurrencyDecimals(currency);

  return <InputNumber {...rest} suffixText={suffixText ? suffixText : currency} decimals={maxCurrencyDecimals} />;
};

export default InputMonetary;
